import anime from "animejs";

class Costs {
    constructor(costsObj) {
        if (!costsObj) {
            console.warn("costsObj is null or undefined");
            return;
        }
        const countriesObjs = costsObj.querySelectorAll(".costs__countryItem");
        const countries = [];
        const numbers = [];

        for (const country of countriesObjs) {
            const countryName = country.getAttribute("data-country")
            countries.push(countryName);
            numbers.push(costsObj.querySelectorAll(`.costs__itemCostNumberItem[data-country=${countryName}]`));
        }

        let current = 0;
        const length = countries.length;
        let next = current + 1 < length ? current + 1 : 0;

        const playNextAnimation = () => {
            anime({
                targets: [...numbers[next], countriesObjs[next]],
                translateY: [10, 0],
                opacity: [0, 1],
                duration: 500,
                delay: 5000,
            });

            anime({
                targets: [...numbers[current], countriesObjs[current]],
                translateY: [0, -10],
                opacity: [1, 0],
                duration: 500,
                delay: 5000,
                complete: () => {
                    current = current + 1 < length ? current + 1 : 0;
                    next = current + 1 < length ? current + 1 : 0;
                    playNextAnimation()
                }
            })

        }

        playNextAnimation();

    };


}

export default Costs;